import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";
import { Button } from "@shadcn/ui/button";
import { Link } from "@tanstack/react-router";
import { toast } from "sonner";
import { authClient } from "./authClient";
import { AuthRoute } from "./AuthRoute";

type VerifyEmailProps = {
	email: string;
};

export const VerifyEmailPage = (props: VerifyEmailProps) => {
	const { email } = props;
	const { show } = AuthRoute.useSearch();
	const { callbackUrl } = AuthRoute.useLoaderData();
	const LL = useI18nContext().LL.auth;

	const onResendEmail = async () => {
		try {
			if (show === "forgot-password") {
				const res = await authClient.requestPasswordReset({
					email,
					redirectTo: callbackUrl,
				});
				if (res.error) {
					throw res.error;
				}
				toast.success(<T>{LL.VERIFY_EMAIL_TOAST_PASSWORD_RESET_EMAIL_SENT()}</T>);
			} else {
				const res = await authClient.sendVerificationEmail({
					email,
					callbackURL: callbackUrl,
				});
				if (res.error) {
					throw res.error;
				}
				toast.success(<T>{LL.VERIFY_EMAIL_TOAST_VERIFICATION_EMAIL_SENT()}</T>);
			}
		} catch (error: any) {
			console.error(error);
			toast.error("message" in error ? (error.message as string) : "Something went wrong, try again later");
		}
	};

	return (
		<>
			<div className="m-auto w-full max-w-sm space-y-6">
				<div className="space-y-2 text-center">
					<h1 className="text-3xl font-bold font-breit">
						<T>{LL.VERIFY_EMAIL_TITLE()}</T>
					</h1>
					<p className="text-muted-foreground text-sm">
						<T>{LL.VERIFY_EMAIL_HERO_DESCRIPTION({ email })}</T>
					</p>
				</div>

				<div className="flex flex-col space-y-4">
					<Button className="w-full" variant="outline" onClick={onResendEmail}>
						<T>{LL.VERIFY_EMAIL_RESEND_EMAIL()}</T>
					</Button>

					<Link
						from={AuthRoute.fullPath}
						search={{ show, verifyEmail: undefined }}
						className="text-foreground underline text-center  text-sm"
					>
						<T>{LL.VERIFY_EMAIL_CHANGE_EMAIL()}</T>
					</Link>
				</div>
			</div>
		</>
	);
};
